import Vue from 'vue'

const messages = {
  tr: {
    meta: {
      title: 'Kamenka Sürücü Kursu'
    },
    app: {
      footer: 'Kamenka Sürücü Kursu'
    },
    common: {
      close: 'Kapat',
      add: 'Ekle',
      save: 'Kaydet',
      delete: 'Sil',
      keep: 'Tut',
      expand: 'Genişlet',
      readMore: 'Devamını oku',
      undo: 'Geri al',
      download: 'İndir',
      unavailable: 'Şu anda kullanılamıyor'
    },
    nav: {
      brandPrimary: 'Kamenka',
      brandSecondary: 'Sürücü Kursu',
      school: 'Kurs Hakkında',
      docs: 'Belgeler',
      events: 'Etkinlikler',
      reviews: 'Yorumlar',
      categories: 'Kategoriler',
      categoryA: 'Kategori A',
      categoryB: 'Kategori B',
      categoryC: 'Kategori C',
      categoryD: 'Kategori D',
      categoryE: 'Kategori E',
      programs: 'Eğitim Programları',
      paidServices: 'Ücretli Hizmetler',
      regulations: 'Yönetmelikler',
      localDocs: 'Yerel Belgeler',
      darkTheme: 'Koyu tema',
      anniversary: 'Bu yıl sürücü kursumuz {years} yaşına giriyor!'
    },
    home: {
      main: 'Ana Sayfa',
      about: 'Kurs Hakkında'
    },
    about: {
      heroLong: 'Profesyonel eğitim kurumu <span class="font-weight-bold">Kamenka Sürücü Kursu</span>, Rusya Savunma, Havacılık ve Denizcilik Gönüllü Destek Topluluğu <span class="font-weight-bold">DOSAAF</span> bünyesinde faaliyet göstermektedir.',
      heroShort: 'POU Kamenka Sürücü Kursu DOSAAF',
      introParagraphs: [
        '<strong>POU Kamenka Sürücü Kursu\'nun kurucusu</strong>, Rusya Savunma, Havacılık ve Denizcilik Gönüllü Destek Topluluğu\'dur (DOSAAF Rusya).',
        '<strong>Tüzel kişilik hakları</strong>, DOSAAF Rusya adına sürekli görev yapan merkezi yönetim organı tarafından kullanılmaktadır.',
        '<strong>Kurucunun adresi</strong>: Moskova, Volokolamsk Şosesi, 88, bina 3'
      ],
      historyPreviewParagraphs: [
        '<strong>Kamenka otomobil ve motosiklet kulübü</strong>, 8 Eylül 1955 tarihinde savaş pilotu Yarbay Vasiliy İvanoviç Saharov tarafından kuruldu. Motosiklet sporu, köpek yetiştiriciliği ve telsiz sporunun yanı sıra temel görev, Sovyet ordusu ve sivil ekonomi için <strong>sürücü yetiştirmekti</strong>. Kuruluşundan bu yana <strong>{years}</strong> yıl içinde yaklaşık <strong>100 bin</strong> sürücü yetiştirildi.',
        '<strong>1974 yılında</strong> kulüp temel alınarak DOSAAF sürücü kursu oluşturuldu.'
      ],
      historyTitle: 'Sürücü kursunun tarihi',
      historyParagraphs: [
        'Otomobil ve motosiklet kulübü, Kamenka ilçe askerlik şubesinin tek katlı ek binasında çalışmalarına başladı. İlk yıllarda ne garaj ne de sürüş pisti vardı. Sadece iki araç ve iki derslik bulunuyordu. Zamanla altyapı güçlendirildi; merkezi ısıtmalı bölgedeki ilk garajlar, eğitim binası, yurt, idari bina eki ve sürüş pisti inşa edildi.',
        'Kulübün gelişimine büyük katkı sağlayan yöneticiler arasında 1 Ocak 1959\'a kadar görev yapan V. İ. Saharov ile 1974\'e kadar görev yapan ve garajlar, ek binalar ile eğitim binasının kurulmasında önemli rol oynayan A. G. Soluyanov yer aldı. 1974 yılında kulüp temelinde DOSAAF sürücü kursu açıldı.',
        'Yeni kurumun başına N. A. Yaşin getirildi. Onu B. Ya. Kurışev ve daha sonra 14 yıl görev yapan M. N. Golikov izledi. Bu dönemde yurt inşa edildi ve yüksek nitelikli öğretmen ile sürüş eğitmeni kadrosu korundu.',
        'Kuruma uzun yıllar emek veren çok sayıda eğitmen ve usta öğretici görev yaptı. Bu ekip, kurumun eğitim kalitesini ve uygulamalı sürüş eğitimini uzun yıllar boyunca sürdürülebilir hale getirdi.',
        'Müdür yardımcıları ve muhasebe ekibi de okulun gelişimine önemli katkı sundu. Bugün hâlâ kurumda görev yapan emektar çalışanlar bulunmaktadır. Sonraki yıllarda kurumun yönetimini S. K. Lukyanov üstlendi; trajik vefatının ardından vekâleten S. E. Korençenko görev yaptı.',
        '2006 yılında okul müdürlüğüne Yu. L. Afonkin atandı. Bu dönemde okul, Sovyetler Birliği Kahramanı Viktor Stepanoviç Parşin\'in adını aldı; eğitim materyalleri yenilendi, atölye ve sınıfların donanımı geliştirildi, araç filosu güncellendi, su ve kanalizasyon altyapısı yenilendi.'
      ],
      categoriesTitle: 'Mevcut Kategoriler',
      fleetTitle: 'Araç Filosu',
      vehicleTitle: 'Araç',
      platformTitle: 'Parkur',
      mastersTitle: 'Usta Öğreticiler',
      teachersTitle: 'Eğitmenler',
      directorTitle: 'Kurum Müdürü',
      contactsTitle: 'İletişim',
      contactDetailsTitle: 'İletişim Bilgileri',
      mapTitle: 'Harita',
      addressLabel: 'POU Kamenka Sürücü Kursu DOSAAF adresi:',
      address: 'Penza bölgesi, Kamenka, Kalinin geçidi, 4a',
      workHoursLabel: 'Çalışma saatleri:',
      workHours: 'Pazartesi - Cuma, 08:00 - 17:00',
      breakLabel: 'Mola:',
      breakHours: '12:00 - 13:00',
      phoneLabel: 'Telefon:',
      emailLabel: 'E-posta:',
      peopleExperience: 'Sürücü kursundaki deneyim: {years} yıl',
      categoryHeaders: {
        category: 'Kategori',
        price: 'Ücret',
        cars: 'Araç Filosu',
        docs: 'Belgeler (şartlar)'
      },
      requiredDocsBase: 'Kimlik, sağlık raporu, fotoğraf (3.5 x 4.5), mezuniyet belgesi veya diploma',
      requiredDocsLicense: 'Kimlik, sağlık raporu, fotoğraf (3.5 x 4.5), sürücü belgesi, mezuniyet belgesi veya diploma',
      requirementMinExperience: 'en az 1 yıllık sürüş deneyimi',
      requirementAge21: 'en az 21 yaş'
    },
    documents: {
      title: 'Sürücü kursuna ait belgeler ve yönetmelikler burada yer alır',
      expand: 'Aç',
      add: 'Ekle',
      closeViewer: 'Kapat'
    },
    events: {
      add: 'Ekle'
    },
    reviews: {
      formTitle: 'Yorum Gönder',
      name: 'Ad Soyad',
      text: 'Yorum metni',
      submit: 'Gönder',
      listTitle: 'Yorumlar',
      recaptchaRequired: 'Lütfen doğrulamayı tamamlayın.',
      unavailable: 'Yorum gönderimi şu anda kullanılamıyor.'
    },
    login: {
      adminTitle: 'Yönetici Girişi',
      login: 'Giriş',
      logout: 'Çıkış',
      email: 'E-posta',
      password: 'Şifre',
      minLength: 'Bu alan en az 3 karakter olmalı',
      wrongPassword: 'Şifre hatalı',
      unavailable: 'Giriş şu anda kullanılamıyor'
    },
    docDialog: {
      title: 'Belgeleri Düzenle',
      sectionName: 'Belge bölümünün adı',
      sectionTag: 'Bölüm etiketi',
      addedDocuments: 'Eklenen belgeler',
      documentName: 'Belge adı',
      addDocuments: 'Belge ekle',
      warning: 'Uyarı',
      deleteConfirm: 'Bu belge bölümünü silmek istediğinize emin misiniz? ({name})'
    },
    eventDialog: {
      title: 'Etkinliği Düzenle',
      heading: 'Başlık',
      body: 'Ana metin',
      addedPhotos: 'Eklenen fotoğraflar',
      photoWillDelete: 'Fotoğraf silinecek',
      addPhotos: 'Fotoğraf ekle',
      photoQuality: 'Fotoğraf kalitesi',
      warning: 'Uyarı',
      deleteConfirm: 'Bu etkinliği silmek istediğinize emin misiniz? ({title})'
    }
  },
  en: {
    meta: {
      title: 'Kamenka Driving School'
    },
    app: {
      footer: 'Kamenka Driving School'
    },
    common: {
      close: 'Close',
      add: 'Add',
      save: 'Save',
      delete: 'Delete',
      keep: 'Keep',
      expand: 'Expand',
      readMore: 'Read more',
      undo: 'Undo',
      download: 'Download',
      unavailable: 'Currently unavailable'
    },
    nav: {
      brandPrimary: 'Kamenka',
      brandSecondary: 'Driving School',
      school: 'About School',
      docs: 'Documents',
      events: 'Events',
      reviews: 'Reviews',
      categories: 'Categories',
      categoryA: 'Category A',
      categoryB: 'Category B',
      categoryC: 'Category C',
      categoryD: 'Category D',
      categoryE: 'Category E',
      programs: 'Training Programs',
      paidServices: 'Paid Services',
      regulations: 'Regulations',
      localDocs: 'Local Documents',
      darkTheme: 'Dark theme',
      anniversary: 'Our driving school turns {years} this year!'
    },
    home: {
      main: 'Home',
      about: 'About School'
    },
    about: {
      heroLong: 'Professional educational institution <span class="font-weight-bold">Kamenka Driving School</span> operating within the Russian Voluntary Society for Assistance to the Army, Aviation and Navy <span class="font-weight-bold">DOSAAF</span>.',
      heroShort: 'POU Kamenka Driving School DOSAAF',
      introParagraphs: [
        '<strong>The founder of POU Kamenka Driving School</strong> is the All-Russian public-state organization DOSAAF of Russia.',
        '<strong>The rights of the legal entity</strong> on behalf of DOSAAF of Russia are exercised by the central governing body of DOSAAF of Russia.',
        '<strong>Founder address</strong>: Moscow, Volokolamsk Highway, 88, building 3'
      ],
      historyPreviewParagraphs: [
        '<strong>The Kamenka automobile and motorcycle club</strong> was founded on September 8, 1955 by combat pilot Lieutenant Colonel Vasily Ivanovich Sakharov. Along with motorcycle sport, dog breeding and radio sport, its main mission was <strong>training drivers</strong> for the Soviet army and civil economy. Over <strong>{years}</strong> years of operation, about <strong>100 thousand</strong> drivers were trained.',
        'In <strong>1974</strong>, the DOSAAF driving school was created on the basis of the club.'
      ],
      historyTitle: 'History of the driving school',
      historyParagraphs: [
        'The automobile and motorcycle club was first located in a one-story extension of the Kamenka district military commissariat. At the beginning there were no garages or driving tracks. The club had only two vehicles and two classrooms. Over time, the infrastructure was strengthened: garages with central heating, an educational building, a dormitory, an annex to the administrative building and a driving ground were built.',
        'A major contribution to the development of the club was made by its heads, including V. I. Sakharov, who served until January 1, 1959, and A. G. Soluyanov, who worked there until 1974 and helped build garages, annexes and the training building. In 1974 the DOSAAF driving school was established on this foundation.',
        'The new school was headed by N. A. Yashin, followed by B. Ya. Kuryshev and later M. N. Golikov, who worked for 14 years. During this period the dormitory was built and a highly qualified team of teachers and driving instructors was preserved.',
        'Many instructors and practical training masters made a significant contribution to the institution. Their experience helped maintain a stable quality of both theoretical and practical driving education.',
        'Deputy heads and the accounting team also played an important role in the school\'s development. Veteran employees still work at the school today. In later years the staff was led by S. K. Lukyanov; after his tragic death, S. E. Korenchenko became acting head.',
        'In 2006, Yu. L. Afonkin was appointed head of the school. During this period the school was named after Hero of the Soviet Union Viktor Stepanovich Parshin, the training facilities were upgraded, workshops and classrooms received modern equipment, the vehicle fleet was renewed, and the water and sewage systems were improved.'
      ],
      categoriesTitle: 'Available Categories',
      fleetTitle: 'Vehicle Fleet',
      vehicleTitle: 'Vehicle',
      platformTitle: 'Training Ground',
      mastersTitle: 'Driving Instructors',
      teachersTitle: 'Teachers',
      directorTitle: 'Institution Head',
      contactsTitle: 'Contacts',
      contactDetailsTitle: 'Contact Details',
      mapTitle: 'Map',
      addressLabel: 'Address of POU Kamenka Driving School DOSAAF:',
      address: 'Penza region, Kamenka, Kalinin lane, 4a',
      workHoursLabel: 'Working hours:',
      workHours: 'Monday - Friday, 08:00 - 17:00',
      breakLabel: 'Break:',
      breakHours: '12:00 - 13:00',
      phoneLabel: 'Phone:',
      emailLabel: 'Email:',
      peopleExperience: 'Experience at the driving school: {years} years',
      categoryHeaders: {
        category: 'Category',
        price: 'Price',
        cars: 'Vehicle Fleet',
        docs: 'Documents (requirements)'
      },
      requiredDocsBase: 'Passport, medical certificate, photo (3.5 x 4.5), school certificate or diploma',
      requiredDocsLicense: 'Passport, medical certificate, photo (3.5 x 4.5), driving licence, school certificate or diploma',
      requirementMinExperience: 'at least 1 year of driving experience',
      requirementAge21: 'at least 21 years old'
    },
    documents: {
      title: 'Documents and regulations of the driving school are available here',
      expand: 'Open',
      add: 'Add',
      closeViewer: 'Close'
    },
    events: {
      add: 'Add'
    },
    reviews: {
      formTitle: 'Send a Review',
      name: 'Name',
      text: 'Review text',
      submit: 'Submit',
      listTitle: 'Reviews',
      recaptchaRequired: 'Please complete the verification.',
      unavailable: 'Review submission is currently unavailable.'
    },
    login: {
      adminTitle: 'Administrator Login',
      login: 'Login',
      logout: 'Logout',
      email: 'Email',
      password: 'Password',
      minLength: 'This field must be at least 3 characters long',
      wrongPassword: 'Incorrect password',
      unavailable: 'Login is currently unavailable'
    },
    docDialog: {
      title: 'Edit Documents',
      sectionName: 'Document section name',
      sectionTag: 'Section tag',
      addedDocuments: 'Added documents',
      documentName: 'Document name',
      addDocuments: 'Add documents',
      warning: 'Warning',
      deleteConfirm: 'Are you sure you want to delete this document section? ({name})'
    },
    eventDialog: {
      title: 'Edit Event',
      heading: 'Title',
      body: 'Main text',
      addedPhotos: 'Added photos',
      photoWillDelete: 'This photo will be deleted',
      addPhotos: 'Add photos',
      photoQuality: 'Photo quality',
      warning: 'Warning',
      deleteConfirm: 'Are you sure you want to delete this event? ({title})'
    }
  }
}

const localeCodes = {
  tr: 'tr-TR',
  en: 'en-US'
}

const getStoredLocale = () => {
  if (typeof window === 'undefined') {
    return 'tr'
  }

  const savedLocale = window.localStorage.getItem('locale')
  return messages[savedLocale] ? savedLocale : 'tr'
}

const state = Vue.observable({
  locale: getStoredLocale()
})

const resolveMessage = (locale, key) => key.split('.').reduce((acc, part) => {
  if (acc && acc[part] !== undefined) {
    return acc[part]
  }

  return null
}, messages[locale])

const interpolate = (value, params = {}) => {
  if (typeof value !== 'string') {
    return value
  }

  return value.replace(/\{(\w+)\}/g, (match, key) => {
    if (params[key] === undefined || params[key] === null) {
      return match
    }

    return params[key]
  })
}

const updateDocument = () => {
  if (typeof document === 'undefined') {
    return
  }

  document.documentElement.lang = state.locale
  document.title = resolveMessage(state.locale, 'meta.title') || resolveMessage('tr', 'meta.title')
}

const i18n = {
  state,
  messages,
  locales: Object.keys(messages),
  t(key, params = {}) {
    const value = resolveMessage(state.locale, key)
    const fallback = resolveMessage('tr', key)
    return interpolate(value !== null ? value : fallback !== null ? fallback : key, params)
  },
  setLocale(locale) {
    if (!messages[locale]) {
      return
    }

    state.locale = locale

    if (typeof window !== 'undefined') {
      window.localStorage.setItem('locale', locale)
    }

    updateDocument()
  },
  formatDate(value) {
    if (!value) {
      return ''
    }

    return new Date(value).toLocaleString(localeCodes[state.locale] || localeCodes.tr)
  },
  localeCode() {
    return localeCodes[state.locale] || localeCodes.tr
  }
}

updateDocument()

export default i18n
